import variables from "./variables";
import people, {currentPlayer} from "./people/people";
import missions from "./missions";
import constants from "./constants";
import places from "./places/places";

const conditions = {
    isMorning: () => (variables.game.time[1] === 0),
    isDay: () => (!(variables.game.time[0] === 2 && variables.game.time[1] === 2)),
    isEvening: () => (variables.game.time[1] === 2),
    isNight: () => (!conditions.isDay()),
    isStartOfDayPart: () => (variables.game.time[0] === 0),
    isTimeForWork: () => (variables.game.time[1] === 0 && (variables.game.time[0] === 0 || variables.game.time[0] === 1) && currentPlayer.isPlayer()),
    isDay02Start: () => (variables.game.date === 1622408400000 && variables.game.time[1] === 0),
    wifeIsHere: (placeID) => (currentPlayer.isPlayer() && people.wife.where === placeID),
    wifeCanTalk: () => (
        (people.wife.where === "homeKitchen" || people.wife.where === "homeBedroom") && people.wife.occupations.get().id !== "sleep"
    ),
    wifeIsSleeping: () => (people.wife.occupations.get().id === "sleep"),
    wifeInBathroom: () => (people.wife.occupations.get().id === "shower"),
    wifeKissingAvailable: () => (people.wife.relations > 22),
    getInfoAboutDrink_01CanBeShown: () => (missions.initCorruption_01.tasks.getInfoAboutDrink_01.isActive() && conditions.wifeCanTalk()),
    wifeHowFeelsTalk: () => (people.wife.relations > 22),
    wifeHowFeelsTalkPillsTreated: () => (variables.game.dateWifeTreatedPill !== 0 && (variables.game.date - variables.game.dateWifeTreatedPill >= constants.missions.daysAfterPillTreat)),
    missions: {
        instructionsActive: () => (missions.initCorruption_01.tasks.checkInstruction_01.isActive() && conditions.isDay()),
        instructionsFin: () => (missions.initCorruption_01.tasks.checkInstruction_01.finished),
        pinaColadaActive: () => (missions.initCorruption_01.tasks.buyADrink_01.isActive() && conditions.isEvening()),
        pillToPinaColada: () => (
            missions.initCorruption_01.tasks.treatWifePill_01.isActive()
            && people.wife.relations > 15 && conditions.isStartOfDayPart()
            && (conditions.isMorning() || conditions.isEvening())
        ),
        tellWifeAboutJobInOfficeIsReady: () => (missions.initCorruption_01.tasks.tellWifeAboutJobOps_01.isActive() && conditions.wifeCanTalk()),
        wifeGoesToInterviewInOffice: () => (
            missions.initCorruption_01.tasks.goToInterviewAsWife_01.isActive() && currentPlayer.isWife() && conditions.isMorning()
        ),
        goHomeAfterWifeGotJob: () => (missions.initCorruption_01.tasks.goHome_01.isActive() && currentPlayer.isPlayer())
    },
    playerInBathroom: () => (currentPlayer.isWife() && places[variables.player.schedule[variables.game.time[1]][variables.game.time[0]]].id === places.homeBathroom.id),
    playerIsAtWork: () => (currentPlayer.isPlayer() && [places.courier.id, places.courierOffice.id].includes(people.player.where)),
    switchToWifeIsDisabled: () => (variables.game.nowIsStory || conditions.isNight() || (conditions.playerIsAtWork() && conditions.isEvening())),
    playerCanGoToBathroomWhenWifeIsThere: () => (
        currentPlayer.isPlayer() && conditions.wifeInBathroom() && people.wife.relations > constants.wife.relationsTo.goToBathroom),
    bathTogether: () => (people.wife.relations > constants.wife.relationsTo.bathTogether)
};

export default conditions;